import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

class EverHonorAddons extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('submit', this.handleSubmit, { signal: this.controller.signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  handleCartUpdate = (event) => {
    event.promise?.then((result) => {
      if (!this.isConnected || result.detail?.didError) return;
      const items = result.detail?.items;
      if (!Array.isArray(items)) return;
      const ids = new Set(items.map((item) => String(item.product_id)));
      this.querySelectorAll('[data-offer-product]').forEach((card) => {
        card.hidden = ids.has(card.dataset.offerProduct);
      });
      this.hidden = !Array.from(this.querySelectorAll('[data-offer-product]')).some((card) => !card.hidden);
    }).catch(() => {});
  };

  handleSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.eh-addon__form')) return;
    event.preventDefault();
    event.stopPropagation();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const payload = new FormData(form);
    const variantId = String(payload.get('id') || '');
    if (!/^\d+$/.test(variantId)) return;
    const root = window.Shopify?.routes?.root || '/';
    const sectionIds = Array.from(new Set(
      Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((element) => element.dataset.sectionId)
        .filter(Boolean)
    )).slice(0, 5);
    if (sectionIds.length) payload.set('sections', sectionIds.join(','));
    payload.set('sections_url', window.location.pathname);
    payload.set('quantity', '1');
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    const buttonText = button.textContent;
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = this.dataset.adding;
    status.textContent = '';
    let added = false;
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise
    }));
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        const message = typeof result.description === 'string' ? result.description : this.dataset.error;
        throw new Error(message);
      }
      added = true;
      const cartResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error(this.dataset.refresh);
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: result.sections,
          source: 'everhonor-addons',
          sourceId: form.id,
          itemCount: 1,
          didError: false
        }
      });
      status.textContent = this.dataset.added;
      button.textContent = this.dataset.added;
      const drawer = document.querySelector('#cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (error) {
      deferred.reject(error);
      status.textContent = added ? this.dataset.refresh : (error.message || this.dataset.error);
      if (added) {
        const link = document.createElement('a');
        link.href = root + 'cart';
        link.textContent = this.dataset.viewCart;
        status.append(' ', link);
      }
    } finally {
      if (!added) {
        form.dataset.busy = 'false';
        button.disabled = false;
        button.textContent = buttonText;
      }
    }
  };
}

if (!customElements.get('everhonor-addons')) customElements.define('everhonor-addons', EverHonorAddons);
